import React, { useState } from 'react';

const PredictiveTable = () => {
  const tableData = [
    { name: 'MyLaptop', status: '50%', gpa: 'Group A', issue: 'Low Disk Space', remediate: true },
    { name: "John'sPC", status: '50%', gpa: 'Group A', issue: 'Low Disk Space', remediate: true },
    { name: 'OfficeDevice', status: '100%', gpa: 'Group G', issue: 'Low Disk Space', remediate: true },
    { name: "Sarah'sMacbook", status: '50%', gpa: 'Group I', issue: 'Low Disk Space', remediate: true },
    { name: 'NoelPC', status: '50%', gpa: 'Group B', issue: 'Low Disk Space', remediate: true },
    { name: 'QatarOffice', status: '0%', gpa: 'Group C', issue: 'Low Disk Space', remediate: true },
    { name: 'DubaiOffice', status: '50%', gpa: 'Group D', issue: 'Low Disk Space', remediate: true },
  ];

  const [currentPage, setCurrentPage] = useState(2);
  const [activeTab, setActiveTab] = useState('Success');
  const itemsPerPage = 5;

  const totalPages = Math.ceil(tableData.length / itemsPerPage);
  const currentData = tableData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageClick = (pageNumber) => setCurrentPage(pageNumber);
  const handleTabSwitch = (tab) => setActiveTab(tab);

  const styles = {
    container: {
      backgroundColor: '#121212',
      color: '#fff',
      padding: '20px',
      borderRadius: '10px',
      fontFamily: 'sans-serif',
    },
    tabs: {
      display: 'flex',
      marginBottom: '20px',
    },
    tab: (active) => ({
      padding: '10px 20px',
      cursor: 'pointer',
      borderRadius: '5px',
      backgroundColor: active ? '#252525' : 'transparent',
      color: active ? '#fff' : '#aaa',
      borderRight: active ? '2px solid #D12929' : 'none',
      borderLeft: active ? '2px solid #D12929' : 'none',
      marginRight: '10px',
    }),
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      marginBottom: '20px',
    },
    th: {
      backgroundColor: '#1e1e1e',
      padding: '12px',
      textAlign: 'left',
      fontWeight: 'bold',
    },
    tr: {
      //backgroundColor: '#181818',
      //borderBottom: '1px solid #2e2e2e',
    },
    td: {
      padding: '12px',
    },
    greenDot: {
      height: '10px',
      width: '10px',
      backgroundColor: '#00ff00',
      borderRadius: '50%',
      display: 'inline-block',
    },
    pagination: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
    },
    pageButton: (active) => ({
      padding: '8px 12px',
      borderRadius: '4px',
      border: active ? '1px solid white' : 'none',
      color: '#fff',
      cursor: 'pointer',
    }),
    arrowButton: {
      padding: '8px 12px',
      borderRadius: '4px',
      border: 'none',
      backgroundColor: '#333',
      color: '#fff',
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.tabs}>
        <div style={styles.tab(activeTab === 'Success')} onClick={() => handleTabSwitch('Success')}>
          Success
        </div>
        <div style={styles.tab(activeTab === 'Failure')} onClick={() => handleTabSwitch('Failure')}>
          Failure
        </div>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Name of The Device</th>
            <th style={styles.th}>Status</th>
            <th style={styles.th}>GPA</th>
            <th style={styles.th}>Staus</th>
            <th style={styles.th}>Remediate</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <tr
              key={index}
              style={{
                ...styles.tr,
                borderRadius: '10.027px',
                background: index % 2 === 0 ? '#161617' : '#232222',
              }}
            >
              <td style={styles.td}>{item.name}</td>
              <td style={styles.td}>{item.status}</td>
              <td style={styles.td}>{item.gpa}</td>
              <td style={styles.td}>{item.issue}</td>
              <td style={styles.td}>{item.remediate && <span style={styles.greenDot}></span>}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={styles.pagination}>
        <button style={styles.arrowButton} onClick={() => handlePageClick(currentPage - 1)} disabled={currentPage === 1}>
          ◀
        </button>
        {Array.from({ length: totalPages }, (_, i) => (
          <button key={i} style={styles.pageButton(currentPage === i + 1)} onClick={() => handlePageClick(i + 1)}>
            {i + 1}
          </button>
        ))}
        <button style={styles.arrowButton} onClick={() => handlePageClick(currentPage + 1)} disabled={currentPage === totalPages}>
          ▶
        </button>
      </div>
    </div>
  );
};

export default PredictiveTable;
